
// @mui material components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import GradientLineChart from "examples/Charts/LineCharts/GradientLineChart";

// Soft UI Dashboard React base styles
import typography from "assets/theme/base/typography";

// Dashboard layout components
import BuildByDevelopers from "layouts/dashboard/components/BuildByDevelopers";
import WorkWithTheRockets from "layouts/dashboard/components/WorkWithTheRockets";
import Projects from "layouts/dashboard/components/Projects";
import OrderOverview from "layouts/dashboard/components/OrderOverview";

// Data
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import gradientLineChartData from "layouts/dashboard/data/gradientLineChartData";
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'utlis/authContext';
import { useState, useEffect } from "react";
import bannerImg from "../../assets/images/landingBanner.png" 

function Dashboard() {
  const { size } = typography;
  const { chart, items } = reportsBarChartData;
  const { isAuthenticated } = useAuth();
  
  const navigate = useNavigate();
  const token = sessionStorage.getItem('access_token');
  if (token==='false'||token===null) {
    navigate('/login', { replace: true });
  }


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox mb={3}>
        <div className="welcome-msg">
              <h2>Welcome to the <span>Telsim Retailer Portal!</span></h2>
            </div>
          {/* <Grid container spacing={3}>
             <Grid item xs={12} sm={6} xl={4}>
               <MiniStatisticsCard
                title={{ text: "Retailer"}}
                // count="$53,000"
                //  percentage={{ color: "success", text: "+55%" }}
                icon={{ color: "primary", component: "public" }}
              /> 
            </Grid>
             <Grid item xs={12} sm={6} xl={4}>
              <MiniStatisticsCard
                title={{ text: "today's users" }}
                //  count="2,300"
                //  percentage={{ color: "success", text: "+3%" }}
                icon={{ color: "primary", component: "public" }}
              />
            </Grid>  
             <Grid item xs={12} sm={6} xl={4}>
              <MiniStatisticsCard
                title={{ text: "new clients" }}
                // count="+3,462"
                // percentage={{ color: "error", text: "-2%" }}
                icon={{ color: "primary", component: "public" }}
              />
            </Grid> 
          </Grid> */}




        </SoftBox>




        {/* <SoftBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={7}>
              <BuildByDevelopers />
            </Grid>
            <Grid item xs={12} lg={5}>
              <WorkWithTheRockets />
            </Grid>
          </Grid>
        </SoftBox>
         */}
        <SoftBox mb={3}>
          <Grid container spacing={3}>
            {/* <Grid item xs={12} lg={5}>
              <ReportsBarChart
                title="active users"
                description={
                  <>
                    (<strong>+23%</strong>) than last week
                  </>
                }
                chart={chart}
                items={items}
              />
            </Grid> */}
             {/* <Grid item xs={12} lg={7}>
              <GradientLineChart
                title="Sales Overview"
                description={
                  <SoftBox display="flex" alignItems="center">
                    <SoftBox fontSize={size.lg} color="success" mb={0.3} mr={0.5} lineHeight={0}>
                      <Icon className="font-bold">arrow_upward</Icon>
                    </SoftBox>
                    <SoftTypography variant="button" color="text" fontWeight="medium">
                      4% more{" "}
                      <SoftTypography variant="button" color="text" fontWeight="regular">
                        in 2021
                      </SoftTypography>
                    </SoftTypography>
                  </SoftBox>
                }
                height="20.25rem"
                chart={gradientLineChartData}
              />
            </Grid>  */}
          </Grid>
        </SoftBox> 



        
        
        <>
          <div className="bg-light" >
            <div className="container">

              <div className="row align-items-center no-gutters">

                <div className=" col-xl-12 col-lg-12 col-md-12 text-lg-right " style={{background:"white",borderRadius:"20px"}}>
                  <img
                    src={bannerImg}
                    alt=""
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>

</>


      </SoftBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default Dashboard;
